<fhm-search-page [gridData]="gridData"
  [showLink]="false"
  [showAdd]="false"
  [showColumnSearch]="false"
  [type]="'venue-sync-payments-search'"
  [valueColumnFn]="valueColumnFn"
  [columns]="['date', 'outletId', 'appPayments', 'appClips', 'paymentCount']">
  <div class="searchControls">
    <fui-filter-form-context>
      <div class="filter">
        <fhm-venue-select-control (valueChange)="venueId = $event" [label]="'fhm.venue-sync-payments-search.filter.venueId'"></fhm-venue-select-control>
        <fui-search-control [(ngModel)]="startDate" class="filter-name"
          [label]="'fhm.venue-sync-payments-search.filter.startDate'"
        [placeholder]="' '"></fui-search-control>
        <fui-search-control [(ngModel)]="endDate" class="filter-name"
          [label]="'fhm.venue-sync-payments-search.filter.endDate'"
        [placeholder]="' '"></fui-search-control>
        <fui-action-button [title]="'Search'" class="filter-button"
          (click)="load()">
        </fui-action-button>
      </div>
    </fui-filter-form-context>
  </div>
  @if (gridData && gridData.length) {
    <div class="searchFooter">
      <br>
        <b>Total App Payments</b> {{totalAppPayments}} <br><br>
        <b>Total App Clips</b> {{totalAppClips}}
      </div>
    }
  </fhm-search-page>


